import React, { useEffect, useState } from "react";

import { Link } from "gatsby";

const PartnerButtons = (props) => {
  const [brands, setBrands] = useState([]);
  const { brand } = props;

  useEffect(() => {
    let b = { ...brand };
    let loc = [];
    brand.locations &&
      brand.locations.forEach((element, index) => {
        if (element && element.location && element.location.active) {
          loc.push({ ...element });
        }
      });
    b = { ...b, locations: [...loc] };
    setBrands({ ...b });
  }, [brand]);
  return (
    <div style={{ marginBottom: "100px" }}>
      {brands.locations && brands.locations.length ? (
        <>
          <h2 style={{ textAlign: "center" }}>
            Order now from any of our locations
          </h2>
          {brands.locations.map((location, i) => (
            <div key={location?.location?.sfAccountId}>
              {console.log(location)}

              {location?.partners?.filter(f=>f?.partner)?.length > 0 ? (
                <Link
                  className="button-main"
                  style={
                    location?.partners?.length > 0
                      ? {
                          margin: "20px auto",
                          textAlign: "center",
                          color: "white",
                          background: brands?.brandColor,
                        }
                      : {
                          margin: "20px auto",
                          textAlign: "center",
                          color: "white",
                          background: brands?.brandColor,
                          opacity: "0.5",
                        }
                  }
                  key={`/${brands?.brandPath}/${location?.location?.sfAccountId}`}
                  to={
                    location?.partners?.length > 0
                      ? `/${brands?.brandPath}/${location?.location?.sfAccountId}`
                      : ""
                  }
                >
                  {location?.location?.city
                    ?.toLowerCase()
                    .split(" ")
                    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                    .join(" ")}
                  , {location?.location?.state?.toUpperCase()}
                </Link>
              ) : (
                <Link
                  className="button-main"
                  style={{
                    margin: "20px auto",
                    textAlign: "center",
                    color: "white",
                    background: brands?.brandColor,
                    opacity: "0.5",
                  }}
                  key={`/${brands?.brandPath}/${location?.location?.sfAccountId}`}
                >
                  {location?.location?.city
                    ?.toLowerCase()
                    .split(" ")
                    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                    .join(" ")}
                  , {location?.location?.state?.toUpperCase()}
                  {" (Coming Soon)"}
                </Link>
              )}
            </div>
          ))}
        </>
      ) : (
        <>
          <h2 style={{ textAlign: "center" }}>{"Launching soon! 🎉"}</h2>
          <div></div>
        </>
      )}
    </div>
  );
};

export default PartnerButtons;
